export default __webpack_public_path__ + "static/media/Human7.b09abc38.png";